import { render } from "./ListeAgentConsignataire.vue?vue&type=template&id=7504053e&ts=true"
import script from "./ListeAgentConsignataire.vue?vue&type=script&lang=ts"
export * from "./ListeAgentConsignataire.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__